// AUTO-GENERATED - Do not edit manually
// Run: node scripts/generate-contentful-defaults.mjs --locale=zh-CN to regenerate

export const claimsSummaryBar = {
  claims_summary_bar: {
    contentful_name: '[DEFAULT] Claims Summary Bar',
    loading_message: '正在加载您的索赔详情...',
    error_message: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '**我们找不到您的医疗支出记录。**您可能输入了错误的详细信息,或者服务可能遇到了问题。您是否想要检查您的信息并重试?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    timeout_message: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '**获取您当前的医疗支出信息所需时间比预期更长。**您是否愿意等待查看您的数据,还是继续填写您的个人资料?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    error_retry_button: '重试',
    error_continue_button: '继续前进',
    timeout_wait_button: '我会等待',
    timeout_continue_button: '让我们继续',
    claims_data_tooltip:
      '这些数字仅供参考,不会影响您的计划排名。近期的医疗账单可能尚未反映在您看到的金额中。如果您的计划有多个保障级别,ALEX仅参考网络内的家庭金额。',
    current_medical_spending: {
      buttonText: '提交',
      placeholderText: '其他反馈(可选)',
      comparisonHelpful: '此比较是否有帮助?',
      feedbackConfirmation: '收到!感谢您的反馈。',
    },
    claims_invalid_user_input: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: 'ALEX 无法找到您的医疗支出',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。您的详细信息与承保公司的任何会员记录都不匹配。您是否想要检查您的信息并重试?',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    claims_timeout_provider_down: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '**ALEX 无法查询您的医疗支出。**运营商正在经历短暂的停机。您可以等待几分钟后重试,或者在没有此信息的情况下继续。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    claims_provider_gone: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value:
                '**抱歉,ALEX 无法查询此承运商的理赔信息。**您的医疗支出详情暂时无法获取。请在没有此信息的情况下继续。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
    claims_rate_limited: {
      nodeType: 'document',
      data: {},
      content: [
        {
          nodeType: 'paragraph',
          content: [
            {
              nodeType: 'text',
              value: '您的医疗支出暂时无法查看',
              marks: [
                {
                  type: 'bold',
                },
              ],
              data: {},
            },
            {
              nodeType: 'text',
              value: '。对于给您带来的不便,我们深表歉意,团队正在努力修复此问题。',
              marks: [],
              data: {},
            },
          ],
          data: {},
        },
      ],
    },
  },
};
